export default __webpack_public_path__ + "static/undraw_message_sent_1030-4a1b8c33ecc458d87a22be048ea405a4.svg";